// src/roles/rolesApi.ts
import { apiClient } from "@maat/api-base";
var rolesApi = {
  getRoles: async () => {
    return apiClient.get("/main/api/roles");
  },
  getRole: async (roleId) => {
    return apiClient.get(`/main/api/roles/${roleId}`);
  },
  getRoleMembers: async (roleId) => {
    return apiClient.get(`/main/api/roles/${roleId}/members`);
  },
  assignRole: async (roleId, userId) => {
    return apiClient.post(`/main/api/roles/${roleId}/members`, { userId });
  },
  createRole: async (data) => {
    return apiClient.post("/main/api/roles", data);
  },
  updateRole: async (roleId, data) => {
    return apiClient.put(`/main/api/roles/${roleId}`, data);
  },
  deleteRole: async (roleId) => {
    return apiClient.delete(`/main/api/roles/${roleId}`);
  },
  /**
   * Copy a role into a new workspace-owned one. The only way to customize a
   * predefined role, which is read-only by design.
   */
  duplicateRole: async (roleId, data) => {
    return apiClient.post(`/main/api/roles/${roleId}/duplicate`, data);
  },
  getAllPermissions: async () => {
    return apiClient.get("/main/api/roles/permissions/all");
  }
};

export {
  rolesApi
};
